import { Card, CardContent } from "@/components/ui/card";
import { usePageMeta } from "@/hooks/use-page-meta";
import { AlertCircle } from "lucide-react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  usePageMeta({
    title: "Page not found | Passport Photo Validator",
    description: "The page you are looking for does not exist.",
    canonicalPath: "/404",
    robots: "noindex,nofollow",
  });

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-muted">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-destructive" />
            <h1 className="text-2xl font-bold text-foreground">Page Not Found</h1>
          </div>
          <p className="mt-4 text-sm text-muted-foreground mb-4">
            The page you're looking for doesn't exist.
          </p>
          <Button asChild>
            <Link href="/">Go Home</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
